import { useQuery } from '@tanstack/react-query'

import { axios, ExtractFnReturnType, QueryConfig } from '@apps-common/lib'
import { ISearchCountModel } from '@apps-common/types/general'
import { IManagementUnitSearchParamsModel } from '@apps-common/types/management/unit'

export const QUERY_KEY_MANAGEMENT_SEARCH_UNITS_COUNT = (model?: IManagementUnitSearchParamsModel, hideOrderUnits?: boolean) =>
  [
    'searchManagementUnitsCount',
    model?.status,
    model?.mCentreId,
    model?.companyId,
    model?.techCompanyId,
    model?.networkType,
    model?.site,
    model?.accountNo,
    model?.imei,
    model?.serialNo,
    model?.mobileNo,
    model?.ipAddress,
    model?.simNo,
    model?.unprocessedCancellations,
    model?.hardwareToBeInvoiced,
    model?.pinnedUnits,
    model?.startDate,
    model?.endDate,
    model?.take,
    model?.orderBy,
    hideOrderUnits
  ].filter(Boolean)

export const searchUnitsCount = async (model: IManagementUnitSearchParamsModel, hideOrderUnits = false): Promise<ISearchCountModel> =>
  axios.post(`/management/unit/UnitsCount?hideOrderUnits=${hideOrderUnits}`, model).then((res) => res.data?.data)

type QueryFnType = typeof searchUnitsCount

type Props = {
  config?: QueryConfig<QueryFnType>
  model: IManagementUnitSearchParamsModel
  hideOrderUnits?: boolean
}

export const useManagementSearchUnitsCount = ({ config, model, hideOrderUnits }: Props) =>
  useQuery<ExtractFnReturnType<QueryFnType>>({
    ...{ ...config, cacheTime: 0 },
    queryKey: QUERY_KEY_MANAGEMENT_SEARCH_UNITS_COUNT(model, hideOrderUnits),
    queryFn: () => searchUnitsCount(model, hideOrderUnits)
  })
